import React from 'react';
import '../styles/PublicPages.css';
import headerImage from '../assets/images/header.png';

const About = () => {
  return (
    <div className="staff-page">
      <div className="auth-container">
        <div className="auth-header">
          <img src={headerImage} alt="HomeCrowd" className="auth-logo" />
        </div>

        <div className="auth-form">
          <div className="about-content">

            <div className="about-section">
              <h2 className="about-section-title">What is HomeCrowd?</h2>
              <p className="about-text">
                HomeCrowd is a student rewards platform that connects college students with their
                favorite brands while earning points for every purchase. We're revolutionizing how
                students engage with their campus community and local businesses.
              </p>
            </div>

            <div className="about-section">
              <h2 className="about-section-title">How it Works</h2>
              <div className="about-features">
                <div className="feature-step">
                  <div className="step-number">1)</div>
                  <div className="step-content">
                    <h3 className="feature-title">Link Your Cards</h3>
                    <p className="feature-text">Securely connect your debit and credit cards to start earning points automatically.</p>
                  </div>
                </div>
                <div className="feature-step">
                  <div className="step-number">2)</div>
                  <div className="step-content">
                    <h3 className="feature-title">Shop & Earn</h3>
                    <p className="feature-text">Make purchases at participating merchants and earn points with every transaction.</p>
                  </div>
                </div>
                <div className="feature-step">
                  <div className="step-number">3)</div>
                  <div className="step-content">
                    <h3 className="feature-title">Redeem Rewards</h3>
                    <p className="feature-text">Use your points to get exclusive merchandise, experiences, and school-specific rewards.</p>
                  </div>
                </div>
                <div className="feature-step">
                  <div className="step-number">4)</div>
                  <div className="step-content">
                    <h3 className="feature-title">Track Progress</h3>
                    <p className="feature-text">Monitor your points, view transaction history, and discover new ways to earn.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="about-section">
              <h2 className="about-section-title">Why Choose HomeCrowd?</h2>
              <ul className="about-list">
                <li><span className="list-highlight">Student-Focused:</span> Built specifically for college students and their unique needs</li>
                <li><span className="list-highlight">School Pride:</span> Earn rewards that celebrate your school spirit and community</li>
                <li><span className="list-highlight">Easy to Use:</span> Simple setup with automatic point earning - no scanning required</li>
                <li><span className="list-highlight">Secure:</span> Bank-level security to protect your financial information</li>
                <li><span className="list-highlight">Free:</span> No fees, no subscriptions - just rewards for being a student</li>
              </ul>
            </div>

            <div className="about-section">
              <h2 className="about-section-title">Our Mission</h2>
              <p className="about-text">
                We believe that being a student should come with perks. Our mission is to help
                students save money, discover new local businesses, and build stronger connections
                with their campus community - all while earning rewards for the purchases they're
                already making.
              </p>
            </div>

            <div className="about-cta">
              <p className="cta-text">Ready to start earning rewards?</p>
              <p className="cta-subtext">
                Download our mobile app or use our browser extension to get started today!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;